import styled from 'styled-components';

import { ClosingIndicator } from '@xing-com/closing-indicator';
import { mediaSmallOrTiny, zIndexSheet } from '@xing-com/layout-tokens';
import { PopOver as DefaultPopOver } from '@xing-com/pop-over';
import { scale170, spaceS, spaceL, spaceXXL, space3XL } from '@xing-com/tokens';

const PopOver = styled(DefaultPopOver)`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  inline-size: min(calc(100vw - ${spaceXXL}), 424px);
  inset-block-start: calc(
    var(--pop-over-viewport-top, 0px) +
      var(--pop-over-viewport-height, 100dvh) / 2
  );
  inset-inline-end: ${spaceL};
  max-block-size: calc(
    var(--pop-over-viewport-height, 100dvh) - ${spaceXXL}
  );
  overflow: hidden;
  padding: ${space3XL} 0 0;
  position: fixed;
  transform: translateY(-50%);
  z-index: ${zIndexSheet};

  /* stylelint-disable-next-line media-query-no-invalid */
  @media ${mediaSmallOrTiny} {
    inline-size: calc(100vw - ${spaceXXL});
    inset-block-start: calc(
      var(--pop-over-viewport-top, 0px) +
        var(--pop-over-viewport-height, 100dvh) - ${spaceL} -
        env(safe-area-inset-bottom, 0px)
    );

    /* Reserve space for the mobile header and device safe areas. */
    max-block-size: calc(
      var(--pop-over-viewport-height, 100dvh) - ${scale170} - ${spaceXXL} -
        env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px)
    );
    transform: translateY(-100%);
  }
`;

const CloseButton = styled(ClosingIndicator)`
  inset-block-start: 0;
  inset-inline-end: 0;
  position: absolute;
`;

const Content = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${spaceL};
  min-block-size: 0;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  padding: 0 ${spaceXXL} ${spaceXXL};
  text-align: center;

  > * {
    flex-shrink: 0;
  }

  /* stylelint-disable-next-line media-query-no-invalid */
  @media ${mediaSmallOrTiny} {
    gap: ${spaceS};
    padding: 0 ${spaceL} ${spaceL};
  }
`;

export const Styled = {
  CloseButton,
  Content,
  PopOver,
};
